import { Classroom } from '@/api/classroom'

const state = () => ({
  webinarQuizzes: [],
  webinarQuiz: null,
  webinarQuizItems: [],
  webinarQuizItem: null,
  savedIdWebinarQuiz: 0,
  loadingWebinarQuiz: false,
  isSuccessWebinarQuiz: false,
  messageWebinarQuiz: '',
  createdWebinarQuiz: {},
  webinarPrePostTest: [],
  webinarPrePostTestPagination: {},
  loadingWebinarPrePostTest: false,
})

const getters = {
  webinarQuizzes: state => state.webinarQuizzes,
  webinarQuiz: state => state.webinarQuiz,
  webinarQuizItems: state => state.webinarQuizItems,
  webinarQuizItem: state => state.webinarQuizItem,
  savedIdWebinarQuiz: state => state.savedIdWebinarQuiz,
  loadingWebinarQuiz: state => state.loadingWebinarQuiz,
  isSuccessWebinarQuiz: state => state.isSuccessWebinarQuiz,
  messageWebinarQuiz: state => state.messageWebinarQuiz,
  createdWebinarQuiz: state => state.createdWebinarQuiz,
  webinarPrePostTest: state => state.webinarPrePostTest,
  webinarPrePostTestPagination: state => state.webinarPrePostTestPagination,
  loadingWebinarPrePostTest: state => state.loadingWebinarPrePostTest,
}

const actions = {
  async fetchAllWebinarQuiz({commit}) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizList()
      .then(res => {
        commit('setIsSuccessWebinarQuiz', true)
        commit('setWebinarQuizzes', res.data.data)
        commit('setLoadingWebinarQuiz', false)
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async fetchAllWebinarQuizFilter({commit}, id) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizListFilter(id)
      .then(res => {
        commit('setSavedIdWebinar', id)
        commit('setIsSuccessWebinarQuiz', true)
        commit('setWebinarQuizzes', res.data.data)
        commit('setLoadingWebinarQuiz', false)
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async fetchDetailWebinarQuiz({commit}, id) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizDetail(id)
      .then(res => {
        commit('setSavedIdWebinarQuiz', id)
        commit('setIsSuccessWebinarQuiz', true)
        commit('setWebinarQuiz', res.data.data)
        commit('setLoadingWebinarQuiz', false)
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async addWebinarQuiz({commit}, data) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizAdd(data)
      .then(res => {
        if(res.data.success) {
          commit('setCreatedWebinarQuiz', res.data.data)
          commit('setIsSuccessWebinarQuiz', true)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Berhasil Menambahkan Pre/Post-Test')
        } else {
          commit('setIsSuccessWebinarQuiz', false)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async updateWebinarQuiz({commit}, data) {
    const id = data.id
    const payload = data.payload

    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizEdit(id, payload)
      .then(res => {
        if(res.data.success) {
          commit('setIsSuccessWebinarQuiz', true)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Berhasil Mengubah Pre/Post-Test')

        } else {
          commit('setIsSuccessWebinarQuiz', false)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async deleteWebinarQuiz({commit}, id) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizDelete(id)
      .then(res => {
        if(res.data.success) {
          commit('setIsSuccessWebinarQuiz', true)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Berhasil Menghapus Pre/Post-Test')

        } else {
          commit('setIsSuccessWebinarQuiz', false)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async fetchAllWebinarQuizItems({commit}) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizItemList()
      .then(res => {
        commit('setIsSuccessWebinarQuiz', true)
        commit('setWebinarQuizItems', res.data.data)
        commit('setLoadingWebinarQuiz', false)
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async fetchAllWebinarQuizItemsFilter({commit}, id) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizItemListFilter(id)
      .then(res => {
        commit('setSavedIdWebinarQuiz', id)
        commit('setIsSuccessWebinarQuiz', true)
        commit('setWebinarQuizItems', res.data.data)
        commit('setLoadingWebinarQuiz', false)
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async fetchDetailWebinarQuizItem({commit}, id) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizItemDetail(id)
      .then(res => {
        commit('setIsSuccessWebinarQuiz', true)
        commit('setWebinarQuizItem', res.data.data)
        commit('setLoadingWebinarQuiz', false)
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async addWebinarQuizItem({commit}, data) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizItemAdd(data)
      .then(res => {
        if(res.data.success) {
          commit('setIsSuccessWebinarQuiz', true)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Berhasil Menambahkan Pertanyaan')
        } else {
          commit('setIsSuccessWebinarQuiz', false)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async updateWebinarQuizItem({commit}, data) {
    const id = data.id
    const payload = data.payload

    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizItemEdit(id, payload)
      .then(res => {
        if(res.data.success) {
          commit('setIsSuccessWebinarQuiz', true)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Berhasil Mengubah Pertanyaan')

        } else {
          commit('setIsSuccessWebinarQuiz', false)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async deleteWebinarQuizItem({commit}, id) {
    commit('setLoadingWebinarQuiz', true)
    await Classroom.webinarQuizItemDelete(id)
      .then(res => {
        if(res.data.success) {
          commit('setIsSuccessWebinarQuiz', true)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Berhasil Menghapus Pertanyaan')

        } else {
          commit('setIsSuccessWebinarQuiz', false)
          commit('setLoadingWebinarQuiz', false)
          commit('setMessageWebinarQuiz', 'Terjadi Kesalahan')
        }
      })
      .catch(err => {
        commit('setIsSuccessWebinarQuiz', false)
        commit('setMessageWebinarQuiz', err)
        commit('setLoadingWebinarQuiz', false)
      })
  },
  async fetchAllWebinarPrePostTest({commit}, query) {
    commit('setLoadingWebinarPrePostTest', true)
    await Classroom.getWebinarPrePostTest(query.perPage, query.page)
    .then(res => {
      commit('setWebinarPrePostTest', res.data.data)
      commit('setWebinarPrePostTestPagination', res.data.pages)
      commit('setLoadingWebinarPrePostTest', false)
    })
    .catch(err => {
      commit('setIsSuccessWebinarQuiz', false)
      commit('setMessageWebinarQuiz', err)
      commit('setLoadingWebinarPrePostTest', false)
    })
  },
}

const mutations = {
  setWebinarQuizzes: (state, webinarQuizzes) => {
    state.webinarQuizzes = webinarQuizzes
  },
  setWebinarQuiz: (state, webinarQuiz) => {
    state.webinarQuiz = webinarQuiz
  },
  setWebinarQuizItems: (state, webinarItems) => {
    state.webinarQuizItems = webinarItems
  },
  setWebinarQuizItem: (state, webinarItem) => {
    state.webinarQuizItem = webinarItem
  },
  setSavedIdWebinarQuiz: (state, idWebinarQuiz) => {
    state.savedIdWebinarQuiz = idWebinarQuiz
  },
  setLoadingWebinarQuiz: (state, loading) => {
    state.loadingWebinarQuiz = loading
  },
  setIsSuccessWebinarQuiz: (state, success) => {
    state.isSuccessWebinarQuiz = success
  },
  setMessageWebinarQuiz: (state, message) => {
    state.messageWebinarQuiz = message
  },
  setCreatedWebinarQuiz: (state, webinarQuiz) => {
    state.createdWebinarQuiz = webinarQuiz
  },
  setWebinarPrePostTest: (state, tests) => {
    state.webinarPrePostTest = tests
  },
  setWebinarPrePostTestPagination: (state, pagination) => {
    state.webinarPrePostTestPagination = pagination
  },
  setLoadingWebinarPrePostTest: (state, loading) => {
    state.loadingWebinarPrePostTest = loading
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}